import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


@Component({
  selector: 'page-stok-deger-rapor',
  templateUrl: 'stok-deger-rapor.html',
})
export class StokDegerRaporPage {
gelenrapor=[];
toplammaliyet:number=0;
toplamsatisdegeri:number=0;
toplamsatissonrasikar:number=0;
  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
 this.RaporuGetir();
  }
RaporuGetir()
{
this.bllOrtak.islemWithoutPost("StokDegerRaporu","",true).then(a=>{
  var sonuc=<any>a;
    this.gelenrapor=sonuc.SonucObject;
    this.gelenrapor.forEach(e=>{
      this.toplammaliyet+=e.Price1*e.Kalan;
      this.toplamsatisdegeri+=e.Price2*e.Kalan;
      this.toplamsatissonrasikar+=e.Price2*e.Kalan-e.Price1*e.Kalan;
    });
})
}

}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/stok-deger-rapor/stok-deger-rapor.ts